/**
 * A readable starting name from a file's name: "week3_demand-curves.pdf"
 * becomes "week3 demand-curves". Only a suggestion; the student can change
 * it before anything is saved.
 */
export function titleFromFileName(fileName: string): string {
  const base = fileName
    .replace(/\.pdf$/i, "")
    .replace(/[_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return base.length > 120 ? `${base.slice(0, 117)}...` : base;
}

/** The title to save: what the student typed, else the suggestion, else a fallback. */
export function chooseTitle(typed: string, fallback: string): string {
  const name = typed.trim().replace(/\s+/g, " ");
  return (name || fallback.trim() || "Untitled reading").slice(0, 200);
}
